import { defaultSettings } from '@/constants/optima';

const defaultThreshold = { weight: 5000, volume: 400 };
const defaultFloor1 = { weight: 3000, volume: 363 };
const defaultFloor2 = { weight: 90, volume: 90 };

const mutation = {
  setLoading(state, status) {
    state.isLoading = status;
  },
  emptyIndent(state, data) {
    state.indents = data;
  },
  setIndents(state, data) {
    const result = (state.filter.page > 1) ? state.indents.concat(data) : data;
    state.indents = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setSelectAll(state, data) {
    state.selectAll = data;
  },
  selectedIndents(state, data) {
    state.selectedIndentMap = data;
  },
  indentIdWiseData(state, data) {
    state.indentIdWiseData = data;
  },
  setUploadDetails(state, data) {
    state.uploadDetails = data;
  },

  setGatesMap(state, data) {
    state.gatesMap = { ...data };
  },
  setRejectedCount(state, data) {
    state.uploadDetails.invalid_count = data.rejectCount;
    state.uploadDetails.rejectedMaterialsPath = data.rejectionXlsPath;
  },
  paginationCheck(state, status) {
    state.isPaginating = status;
  },
  setSummary(state, data) {
    state.notCombineConisgnee = [];
    state.holdConsigneesWithDelivery = [];
    state.summaryConsignees = data.consigneeList;
    state.summaryDeliveryNos = data.summary.map(consignee => ({ consignee_id: consignee.consignee_id, delivery_nos: consignee.delivery_nos.map(delivery => ({ delivery_no: delivery, checked: false })) }));
  },
  isIndentUpdating(state, status) {
    state.isUpdating = status;
  },
  updateIndent(state, data) {
    state.indentDetails = data;
  },
  setIndentIds(state, data) {
    state.editIndentIds = data;
  },
  editIndents(state, data) {
    state.editIndents = data;
  },
  deleteIndents(state, ids) {
    state.indents = state.indents.filter(indent => ids.indexOf(indent.id) === -1);

    if (state.editIndents.length) {
      state.editIndents = state.editIndents.filter(indent => ids.indexOf(indent.id) === -1);
    }
  },
  setMaterials(state, data) {
    state.consigneeMaterials = data;
  },
  setOrderDetails(state, data) {
    state.orderDetails = data;
  },
  setIndent(state, data) {
    state.indent = data;
  },
  setSetting(state, data) {
    const depotSettings = { ...data.optima_configuration };
    if (!depotSettings.pickup_threshold) {
      depotSettings.pickup_threshold = { ...defaultThreshold };
    }
    if (!depotSettings.floor_one) {
      depotSettings.floor_one = { ...defaultFloor1 };
    }
    if (!depotSettings.floor_two) {
      depotSettings.floor_two = { ...defaultFloor2 };
    }
    state.settings = { ...depotSettings };
  },
  makeEmptySetting(state, data) {
    state.settings = { ...data };
  },
  setDefaultSetting(state, data) {
    const depotSettings = data;
    depotSettings.pickup_threshold = { ...defaultThreshold };
    depotSettings.floor_one = { ...defaultFloor1 };
    depotSettings.floor_two = { ...defaultFloor2 };
    state.settings = { ...depotSettings };
  },
  setMovement(state, Id) {
    state.defaultDepot.movement = Id;
  },
  setDeliveryStatus(state, { routeSettings, data, index }) {
    routeSettings.delivery_split_status.forEach((statusObj, i) => {
      if (index === i) {
        statusObj.delivery_status_value = data;
      }
    });
  },
  setCustomParamsName(state, { routeSettings, data, index, type }) {
    routeSettings.custom_params.forEach((statusObj, i) => {
      if (index === i) {
        statusObj.name = data;
        statusObj.type = type;
        if (type === 'boolean') {
          statusObj.value = false;
        }
      }
    });
  },
  setDefaultDepot(state, { depotId, movement }) {
    state.defaultDepot.depot_id = depotId;
    state.defaultDepot.movement = movement;
  },
  setVehicles(state, data) {
    const ftlVehicles = data.filter(vehicle => vehicle.vehicle_type === 'FTL');
    state.vehicles = ftlVehicles;
  },
  setPage(state, data) {
    state.filter.page = data;
  },
  setNotCombineList(state, data) {
    state.not_combines = data;
  },
  depotDeliveryList(state, data) {
    let depotIds = [];
    if (data.length) {
      depotIds = data[0].depot_ids;
    }
    state.depotDeliveryList = depotIds;
  },
  isDeliveryPickLoading(state, data) {
    state.isDeliveryPickLoading = data;
  },
  holdConsigneeChange(state, data) {
    if (data.status) {
      const consigneeIndex = state.holdConsigneesWithDelivery.findIndex(consignee => consignee.consignee_id === data.consignee_id);
      if (consigneeIndex !== -1) {
        state.holdConsigneesWithDelivery[consigneeIndex].delivery_nos = data.deliveryNos;
      } else {
        state.holdConsigneesWithDelivery.push({ consignee_id: data.consignee_id, delivery_nos: data.deliveryNos });
      }
    } else {
      const index = state.holdConsigneesWithDelivery.findIndex(consignee => consignee.consignee_id === data.consignee_id);
      if (index !== -1) {
        state.holdConsigneesWithDelivery.splice(index, 1);
        state.holdConsigneesWithDelivery = state.holdConsigneesWithDelivery;
      }
    }
  },
  changeNotCombine(state, data) {
    if (data.status) {
      state.notCombineConisgnee.push(data.consignee_id);
    } else {
      const index = state.notCombineConisgnee.indexOf(data.consignee_id);
      if (index !== -1) {
        state.notCombineConisgnee.splice(index, 1);
        state.notCombineConisgnee = state.notCombineConisgnee;
      }
    }
  },
  holdDeliveryWise(state, data) {
    const consigneeDeliveryNos = [...state.holdConsigneesWithDelivery];
    const index = consigneeDeliveryNos.findIndex(consignee => consignee.consignee_id === data.consignee_id);
    if (index !== -1) {
      const deliveryNumbers = consigneeDeliveryNos[index].delivery_nos;
      const deliveryIndex = deliveryNumbers.findIndex(delivery => delivery.delivery_no === data.number);

      if (deliveryIndex !== -1 && !data.status) {
        deliveryNumbers.splice(deliveryIndex, 1);
        consigneeDeliveryNos[index].delivery_nos = deliveryNumbers;
        if (consigneeDeliveryNos[index].delivery_nos.length === 0) {
          consigneeDeliveryNos.splice(index, 1);
        }
      }
      if (data.status) {
        consigneeDeliveryNos[index].delivery_nos.push({ delivery_no: data.number, checked: false });
      }
    } else {
      consigneeDeliveryNos.push({ consignee_id: data.consignee_id, delivery_nos: [{ delivery_no: data.number, checked: false }] });
    }
    state.holdConsigneesWithDelivery = consigneeDeliveryNos;
  },
  reOptimizeSummary(state, data) {
    state.reOptimize = data;
  },
  setHoldConisgnee(state, data) {
    state.holdConisgnees = data;
  },
  setnotCombineConisgnee(state, data) {
    state.notCombineConisgnee = data;
  },
  setIndentCount(state, data) {
    state.indentCount = data;
  },
  setDeliveryPickStatus(state, data) {
    state.deliveryPickList.status = data;
  },
  setDeliveryPage(state, data) {
    state.deliveryPickList.page = data;
  },
  setDeliveryNumber(state, data) {
    state.deliveryPickList.delivery_number = data || null;
  },
  depotWiseDeliveryNos(state, data) {
    const result = (state.deliveryPickList.page > 1) ? state.depotWiseDeliveryNos.concat(data) : data;
    state.depotWiseDeliveryNos = result;
    if (data.length) {
      state.deliveryPickList.page += 1;
      state.deliveryNosHasEmpty = false;
    } else {
      state.deliveryNosHasEmpty = true;
    }
  },
  setDeliveryPicklistMeta(state, data) {
    state.deliveryPicklistMeta = data || {};
  },
  setDeliveryProcessedCounts(state, data) {
    state.deliveryProcessedCounts = data;
  },
  setInvalidPath(state, data) {
    state.setInvalidPath = data;
  },
  setOptimaAutoRun(state, data) {
    state.optimaAutoRun = data;
  },
  setOptimaAutoIndent(state, data) {
    state.optimaAutoIndent = data;
  },
  // setSelectedIndents(state, data) { // TODO need to remove after testing
  //   state.selectedIndents = data;
  // },
  resetSelectedIndents(state) {
    const selectedIndentMap = state.selectedIndentMap;
    state.indents.forEach((indent) => {
      selectedIndentMap[indent.id] = false;
    });
    state.selectedIndentMap = selectedIndentMap;
  },
  setSelectedIndentMap(state, data) {
    state.selectedIndentMap = data;
  },
  setIndentIdWiseData(state, data) {
    state.indentIdWiseData = data;
  },
  setIndentBucket(state, data) {
    state.indentBucket = data;
  },
  setEmptyRejectionListData(state, data) {
    const result = (state.detailsPage > 1) ? state.optimaRejectionsListData.concat(data) : data;
    state.optimaRejectionsListData = result;
    if (data.length) {
      state.detailsPage += 1;
      state.hasEmpty = false;
    } else {
      state.optimaRejectionsListData = [];
      state.hasEmpty = true;
    }
  },
  addMovement(state, data) {
    let res = false;
    state.movement_list.forEach((element) => {
      if (element.id === data.id) {
        res = true;
      }
    });
    if (!res) {
      state.movement_list.push(data);
    }
  },
  setRejectionListData(state, data) {
    const result = (state.detailsPage > 1) ? state.optimaRejectionsListData.concat(data) : data;
    state.optimaRejectionsListData = result;
    if (data.length) {
      state.detailsPage += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  initialRejectionReset(state) {
    state.detailsPage = 1;
    state.hasEmpty = false;
    state.optimaRejectionsListData = [];
  },
  setOptimaCurrentJobId(state, jobId) {
    state.optimaCurrentJobId = jobId;
  },
  setOptimaCurrentPage(state, page) {
    state.optimaCurrentPage = page;
  },
  setDeliveryPicklist(state, data){
    data.forEach(picklist => {
      state.selectedPicklistMap[picklist.s_no] = false;
      state.picklistIdsMap[picklist.s_no] = picklist.optima_material_ids;
    });
    let result;
    if (state.filter.page > 1) {
      result = state.deliveryPicklist.concat(data);
    } else {
      result = data;
    }
    state.deliveryPicklist = result;
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  setSelectedPicklistMap(state, data) {
    state.selectedPicklistMap = data;
  },
  setPicklistIdsMap(state, data) {
    state.picklistIdsMap = data;
  },
  setSelectAllPicklistConsignees(state, data) {
    state.selectAllPicklistConsignees = data;
  },
  setDeliveryIndentsPickList(state, data) {
    state.deliveryIndentsPickList = data;
  },
  setShowIndentTopupDrawer(state, data) {
    state.showIndentTopupDrawer = data;
  },
  setSplitObject(state, data) {
    state.splitObject = data;
  },
  setCombineObject(state, data) {
    state.combineObject = data;
  },
  setSplitOrderSelectedIndex(state, data) {
    state.splitOrderSelectedIndex = data;
  },
  setCombineOrderSelectedIndex(state, data) {
    state.combineOrderSelectedIndex = data;
  },
  setReturnContracts(state, data) {
    state.returnContracts = data;
  },
  setCombineAndSplitBtnDisable(state, data) {
    state.combineAndSplitBtnDisable = data;
  },
  setContractCollection(state, data) {
    state.contractCollection = data;
  },
};
export default mutation;
